import { path } from 'ramda'

import { isPromise } from '@/lib/helpers.js'
import { DEVICE_CLASSES } from './consts.js'
import DeviceIdentity from './device-identity.js'

export default class NativeIdentity {
  constructor ({ apiCall, getToken, logger }) {
    this.__apiCall = apiCall
    this.__getToken = getToken
    this.__logger = logger
    this.__addDeviceIdentities()
  }

  __addDeviceIdentities () {
    const classes = Object.values(DEVICE_CLASSES)
    this.__deviceIdentities = classes.map(this.__addDeviceIdentity.bind(this))
  }

  __addDeviceIdentity (DeviceClass) {
    const isValid = DeviceClass && DeviceClass.prototype instanceof DeviceIdentity

    if (isValid) {
      return new DeviceClass({
        apiCall: this.__apiCall,
        logger: this.__logger,
      })
    }

    this.__logger.error('Object doesn\'t has DeviceIdentity as base class')
  }

  async tokenAction ({ action, business, webView }) {
    const data = { action, business, webView }

    this.__logger.log('Token action started', data)

    const identity = this.__getDeviceIdentity({ webView })
    const businessId = path(['id'], business)

    try {
      this.__validateTokenAction({ action, businessId, identity })

      const token = await this.__tryToGetToken()
      const result = identity[action]({ businessId, token })

      if (isPromise(result)) {
        return result.finally(() => {
          this.__logger.log('Token action settled', data)
        })
      }

      throw new Error('Token action result is not a promise')
    } catch (error) {
      this.__logger.error(error, data)
      return Promise.reject(error)
    }
  }

  __getDeviceIdentity ({ webView }) {
    return this.__deviceIdentities.find(deviceIdentity => {
      const DeviceClass = DEVICE_CLASSES[webView]
      return DeviceClass && deviceIdentity instanceof DeviceClass
    })
  }

  __validateTokenAction ({ action, businessId, identity }) {
    if (!identity) {
      throw new Error('Identity is not defined')
    }

    if (!businessId) {
      throw new Error('businessId is not defined')
    }

    if (typeof identity[action] !== 'function') {
      throw new Error('Action must be a function')
    }
  }

  async __tryToGetToken () {
    try {
      const token = await this.__getToken()

      if (!token) {
        throw new Error('Token is not defined')
      }

      return token
    } catch (error) {
      throw new Error(error)
    }
  }
}
